export default __webpack_public_path__ + "static/media/property_634.1bb83e47.png";